import React from 'react'
import { func, object } from 'prop-types'
import intl from 'react-intl-universal'
import { branch } from 'baobab-react/higher-order'
import triggerEvent from 'utils/dataLayer'

import DesktopMenuItem from './DesktopMenuItem'
import DesktopMenuDropdown from './DesktopMenuDropdown'

const DesktopMenu = ({ currentUser, dropdownOnClick }) => (
  <>
    <div className="menu-left hidden-md-down">
      <DesktopMenuItem
        link="/directory"
        text={intl.get('campus')}
        currentUser={currentUser}
        onClick={() => triggerEvent('ga/global/menu-navbar/campus')}
      />
      <DesktopMenuItem
        link="/majors"
        text={intl.get('navs.majors')}
        currentUser={currentUser}
        onClick={() => triggerEvent('ga/global/menu-navbar/major')}
      />
      <DesktopMenuItem
        link="/careers"
        text="Karier"
        currentUser={currentUser}
        onClick={() => triggerEvent('ga/global/menu-navbar/career')}
      />
      <DesktopMenuItem
        link="/scholarships"
        text="Beasiswa"
        currentUser={currentUser}
        onClick={() => triggerEvent('ga/global/menu-navbar/scholarship')}
      />
      <DesktopMenuItem
        link="/tests"
        text="Uji
        Potensi"
        currentUser={currentUser}
        onClick={() => triggerEvent('ga/global/menu-navbar/test')}
      />
      <DesktopMenuItem
        link="/peluang-sbmptn"
        text="Cek
        Peluang"
        currentUser={currentUser}
        onClick={() => triggerEvent('ga/global/menu-navbar/prediction')}
      />
      <DesktopMenuItem
        link="/partners"
        text={intl.get('partners')}
        currentUser={currentUser}
        onClick={() => triggerEvent('ga/global/menu-navbar/partner')}
      />
    </div>
    <div className="menu-right hidden-md-down">
      {
          !currentUser &&
          <DesktopMenuItem
            link="/signin"
            border
            text={intl.get('login')}
            onClick={() => triggerEvent('ga/global/button-navbar/signin')}
          />
        }
      {
        !currentUser &&
        <DesktopMenuItem
          link="/signup"
          border
          filled
          text={intl.get('sign_up')}
          onClick={() => triggerEvent('ga/global/button-navbar/signup')}
        />
      }
      { currentUser &&
        <DesktopMenuDropdown
          name={currentUser.name}
          dropdownOnClick={dropdownOnClick}
          onClick={() => triggerEvent('ga/global/button-navbar/profile')}
        /> }
    </div>
    <style jsx>{`

      .menu-left {
        display: inline-block;

        @media screen and (min-width: 768px){
          margin-right: 40px;
        }
      }

      .menu-right {
        display: inline-block;

        @media screen and (min-width: 768px){
          margin-right: 5px;
        }
      }
    `}
    </style>
  </>
)

DesktopMenu.propTypes = {
  currentUser: object,
  dropdownOnClick: func,
}

export default branch({
  currentUser: ['serverProps', 'currentUser'],
}, DesktopMenu)

